import React from "react";
import { useParams } from "react-router-dom";
import { useT } from "@/i18n/i18n";

const DOCS = {
  privacy: { pl: "Polityka prywatności", en: "Privacy Policy" },
  terms: { pl: "Regulamin", en: "Terms of Use" },
  data: { pl: "Informacja o przetwarzaniu danych", en: "Data Processing Notice" },
  cookies: { pl: "Informacja o cookies", en: "Cookie Notice" },
};

export default function Legal() {
  const { doc } = useParams();
  const { lang } = useT();
  const L = (pl, en) => (lang === "pl" ? pl : en);
  const meta = DOCS[doc] || DOCS.privacy;
  return (
    <div className="mx-auto max-w-3xl px-4 py-16">
      <div className="mb-2 inline-block rounded bg-warnbg px-2 py-0.5 text-xs font-semibold text-warntext">{L("PROJEKT / SZKIC", "DRAFT")}</div>
      <h1 className="font-heading text-3xl font-bold text-charcoal">{meta[lang] || meta.en}</h1>
      <div className="mt-6 space-y-4 text-sm leading-relaxed text-mutedtext">
        <p>{L(
          "To jest szkic dokumentu przygotowany na potrzeby pilotażu. Nie stanowi porady prawnej ani formalnego poświadczenia zgodności z RODO. Ostateczna treść wymaga weryfikacji przez wykwalifikowanych polskich i unijnych specjalistów.",
          "This is a draft prepared for the pilot. It does not constitute legal advice or a formal GDPR compliance certification. Final content requires review by qualified Polish and EU professionals."
        )}</p>
        <p>{L(
          "Nie wyświetlamy publicznie danych osobowych. Dane operacyjne są izolowane na poziomie organizacji, a dostęp jest oparty na rolach.",
          "We do not display personal data publicly. Operational data is isolated at the organization level and access is role-based."
        )}</p>
        <p>{L(
          "W sprawie ochrony danych i pytań prosimy o kontakt przez formularz kontaktowy.",
          "For data protection questions, please use the contact form."
        )}</p>
      </div>
    </div>
  );
}
